import { inLight } from '../lib/geometry.js';
import { objectiveProgress } from '../systems/objective.js';
import { formatTime, loadBest } from '../systems/score.js';
import type { World } from '../world/types.js';

export function setKoTotal(world: World): void {
  const el = document.getElementById('koTotal');
  if (el) el.textContent = String(world.guards.length);
}

/** Read the saved best run from storage and refresh the HUD label. */
export function updateBest(levelId: string): void {
  const el = document.getElementById('bestRank');
  if (!el) return;
  const best = loadBest(levelId);
  if (!best) {
    el.textContent = '—';
    return;
  }
  el.textContent = `${best.rank} · ${formatTime(best.time)}`;
}

export function updateHUD(world: World): void {
  const status = document.getElementById('status');
  const koCount = document.getElementById('koCount');
  if (!status) return;

  const { player, guards, cooldowns } = world;

  let anyChase = false;
  let anySus = false;
  let kos = 0;
  for (const g of guards) {
    if (g.ko) {
      kos++;
      continue;
    }
    if (g.state === 'chase') anyChase = true;
    else if (g.state === 'suspicious' || g.state === 'investigate') anySus = true;
  }

  if (koCount) koCount.textContent = String(kos);

  // Dynamic objective label.
  const objEl = document.getElementById('objective');
  if (objEl) objEl.textContent = objectiveProgress(world).label;

  status.classList.remove('warn', 'danger');
  if (player.inBox) {
    status.textContent = '📦 CACHÉ DANS LA BOÎTE';
  } else if (anyChase) {
    status.textContent = '🚨 REPÉRÉ — FUIS !';
    status.classList.add('danger');
  } else if (anySus) {
    status.textContent = '⚠️ SUSPECT';
    status.classList.add('warn');
  } else if (inLight(world, player)) {
    status.textContent = '☀️ DANS LA LUMIÈRE';
    status.classList.add('warn');
  } else {
    status.textContent = '🌑 FURTIF';
  }

  // Cooldown rings on the mobile ability buttons
  for (const el of document.querySelectorAll<HTMLDivElement>('.ab')) {
    const k = el.dataset['ab'] as keyof typeof cooldowns | undefined;
    if (!k) continue;
    if (cooldowns[k] > 0) el.classList.add('cd');
    else el.classList.remove('cd');
  }
}
